import { BaseResponse } from './base-response.model';
import { UserSummaryJSON } from './user-summary.model';
import { UntypedFormGroup } from '@angular/forms';

export class UserSearchResponse extends BaseResponse {
	constructor(
		public message: string,
		public searchResult: UserSummaryJSON[],
		public options: UserSearchJSON
	) {
		super(message);
	}
}

export interface UserSearchJSON {
	search: string;
	includeArchivedUsers: boolean;
}

export class UserSearch {
	constructor(
		public search: string,
		public includeArchivedUsers: boolean
	) {}

	static fromJSON(json: UserSearchJSON): UserSearch {
		const search = Object.create(UserSearch.prototype);
		return Object.assign(search, json, {});
	}

	static getSearchOptions(searchForm: UntypedFormGroup): UserSearch {
		return new UserSearch(
			searchForm.value['search'],
			searchForm.value['includeArchivedUsers']
		);
	}
}
